export enum EventType {
  FW_LIVE_HELPER_RENDER = 'fw:live-helper:render',

  FW_LIVE_HELPER_IMPRESSION = 'fw:live-helper:impression',
  FW_LIVE_HELPER_CLICK_WIDGET = 'fw:live-helper:click-widget',
  FW_LIVE_HELPER_CLICK_CALL_AGENT = 'fw:live-helper:click-call-agent',
  FW_LIVE_HELPER_CLICK_CHAT_WITH_AGENT = 'fw:live-helper:click-chat-with-agent',
  FW_LIVE_HELPER_AGENT_ANSWER_CALL = 'fw:live-helper:agent-answer-call',
  FW_LIVE_HELPER_AGENT_ANSWER_CHAT = 'fw:live-helper:agent-answer-chat',

  FW_LIVE_HELPER_START_CONVERSATION = 'fw:live-helper:start-conversation',

  FW_LIVE_HELPER_NAVIGATE = 'fw:live-helper:navigate',

  FW_LIVE_HELPER_SUBMIT_CUSTOMER_SURVEY = 'fw:live-helper:submit-customer-survey',
}
